import { render, staticRenderFns } from "./ownService.vue?vue&type=template&id=641ccd80&scoped=true&"
import script from "./ownService.vue?vue&type=script&lang=js&"
export * from "./ownService.vue?vue&type=script&lang=js&"
import style0 from "./ownService.vue?vue&type=style&index=0&id=641ccd80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ccd80",
  null
  
)

export default component.exports